export default {
    BOX: 'box',
    CARD: 'card',
  }
  